import * as e from "react";
const t = (t2) => e.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t2 }, e.createElement("g", { clipPath: "url(#clip0_3344_16311)" }, e.createElement("path", { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" })), e.createElement("defs", null, e.createElement("clipPath", { id: "clip0_3344_16311" }, e.createElement("rect", { width: 24, height: 24 }))));
export {
  t as default
};
//# sourceMappingURL=AddIcon.svg.js.map
